import React from 'react';
import AppointmentTypes from './AppointmentTypes';

/**
 * Cadastros > Tipos de atendimento: página própria dos atendimentos modulares.
 * Título, lista, editor e ações ficam em AppointmentTypes (o botão de adicionar
 * mora no cabeçalho, ao lado do título).
 */
const AppointmentTypesPage = () => {
    return (
        <div className="page-content">
            <AppointmentTypes />
        </div>
    );
};

export default AppointmentTypesPage;
